import styled from 'styled-components';

export type SidebarSide = 'left' | 'right';

interface SlideWrapperProps {
  $isOpen: boolean;
  $side: SidebarSide;
  $width: string;
}

/**
 * The width lives here rather than on the inner wrapper so a panel can ask for `100%` and
 * get the whole stage: an absolutely positioned box with no width shrinks to fit its
 * child, which would make a percentage on that child resolve against itself.
 */
export const SlideWrapper = styled.div<SlideWrapperProps>(
  ({ theme: { transition }, $isOpen, $side, $width }) => ({
    position: 'absolute',
    top: 0,
    [$side]: 0,
    height: '100%',
    width: $width,
    zIndex: 3,
    transform: $isOpen
      ? 'translateX(0)'
      : `translateX(${$side === 'left' ? '-100%' : '100%'})`,
    transition: transition.standard('transform', 'width'),
  }),
);

export const InnerWrapper = styled.div(({ theme: { color, size } }) => ({
  height: '100%',
  width: '100%',
  backgroundColor: color.background.reversed.default(),
  padding: size.units(3),
  paddingBottom: size.units(5),
  display: 'flex',
  flexDirection: 'column',
}));

export const Header = styled.div({
  display: 'flex',
  justifyContent: 'flex-end',
});

export const Content = styled.div({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  overflow: 'hidden',
});

export const Overlay = styled.div<{ $isOpen: boolean }>(
  ({ theme: { color, transition }, $isOpen }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 2,
    background: color.background.reversed.default(0.5),
    transition: transition.standard('opacity'),
    opacity: $isOpen ? 1 : 0,
    pointerEvents: $isOpen ? 'auto' : 'none',
  }),
);
